<template>
  <section>
    <b-modal
      :active.sync="isComponentPassActive"
      has-modal-card
      :can-cancel="false"
    >
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p class="modal-card-title">Cambiar Contraseña</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Contraseña Actual">
            <b-input
              type="password"
              v-model="user.current_password"
              placeholder="Contraseña Actual"
              required
            ></b-input>
          </b-field>

          <b-field label="Contraseña Nueva">
            <b-input
              type="password"
              v-model="user.password"
              placeholder="Nueva Contraseña"
              required
            ></b-input>
          </b-field>
          <b-field label="Repita su nueva contraseña">
            <b-input
              type="password"
              v-model="user.password_confirmation"
              placeholder="Repite Contraseña"
              required
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeEditPassword()">
            Cerrar
          </button>
          <button class="button is-primary" @click="editPassword()">
            Editar
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { UserService } from '../services/models/user';
export default {
  props: ["isComponentPassActive", "closeEditPassword", "user_id"],
  data() {
    return {
      user: {
        current_password: "",
        password: "",
        password_confirmation: "",
      },

      isLoading: true,
    };
  },
  created: function () {
    this.isLoading = false;
  },
  methods: {
    async editPassword () {
      this.$buefy.dialog.confirm({
        message: "¿Desea Continuar?",
        confirmText: "Si",
        type: "is-primary",
        hasIcon: true,
        onConfirm: async () => {
          this.isLoading = true;
          let data = {
            current_password: this.user.current_password,
            password: this.user.password,
            password_confirmation: this.user.password_confirmation,
          };
          try {
            await UserService.changePassword(this.user_id, data);
            this.closeEditPassword();
            this.toast("Editada la contraseña", "is-success");
          } catch (error) {
            this.toast("error al editar", "is-danger");
          }
          this.isLoading = false;
        },
      });
    },
  },
};
</script>